export default __webpack_public_path__ + "static/media/paypal-logo.453db295.svg";